import { fmtNum, StatLabel, SplitVal } from '../common';
import { weekRosterStats } from './stats';
import type { RosterMode } from './types';
import type { Shift } from './types';

import { DOW_ABBR, MONTHS_ABBR } from '../../lib/dates';

export interface RosterStatStripProps {
  shifts: Shift[];
  dogsByDate: Map<string, number>;
  dates: string[];
  helpers: number;
  // Whether the stats summarise the shown week or month — drives the labels.
  period: RosterMode;
}

// Four-card roster snapshot — supply against demand for the shown window:
// Helpers / Shifts (filled vs open) / Hours covered / Dogs (avg vs peak). The
// peak card names the busiest day so understaffing has somewhere to point.
// Read display; mirrors BookingsStatStrip's bw-stats layout.
export function RosterStatStrip({ shifts, dogsByDate, dates, helpers, period }: RosterStatStripProps) {
  const s = weekRosterStats(shifts, dogsByDate, dates, helpers);
  // Week: the weekday is enough. Month: name the date so the peak is unambiguous.
  const peakLabel = !s.peakDay
    ? '—'
    : period === 'week'
      ? DOW_ABBR[new Date(s.peakDay + 'T00:00:00').getDay()]
      : `${new Date(s.peakDay + 'T00:00:00').getDate()} ${MONTHS_ABBR[new Date(s.peakDay + 'T00:00:00').getMonth()]}`;

  return (
    <div className="bw-stats four">
      <div className="bw-stat">
        <StatLabel icon="user">Helpers</StatLabel>
        <div className="val mono">{fmtNum(helpers)}</div>
      </div>
      <div className="bw-stat">
        <StatLabel icon="calendar">Shifts · {period}</StatLabel>
        <SplitVal a={s.filled} b={s.open} aLabel="Filled" bLabel="Open" />
      </div>
      <div className="bw-stat">
        <StatLabel icon="clock">Hours · {period}</StatLabel>
        <div className="val mono">{fmtNum(s.hours)}</div>
      </div>
      <div className="bw-stat">
        <StatLabel icon="paw">Dogs in · {period}</StatLabel>
        <SplitVal a={s.avgDogs} b={s.peakDogs} aLabel="Avg / day" bLabel={`Peak · ${peakLabel}`} />
      </div>
    </div>
  );
}
